import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43476 12.8512 1.80964 13.4763C1.18452 14.1014 0.833332 14.9493 0.833332 15.8333V17.5M17.5 17.5V15.8333C17.4996 15.0948 17.2521 14.3773 16.7956 13.7936C16.3392 13.2099 15.6993 12.793 14.9783 12.6075M12.3117 2.94083C13.034 3.12575 13.6752 3.54254 14.1326 4.12673C14.5899 4.71092 14.8378 5.42913 14.8378 6.16833C14.8378 6.90753 14.5899 7.62574 14.1326 8.20993C13.6752 8.79412 13.034 9.21091 12.3117 9.39583M10.8333 6.16667C10.8333 8.00762 9.34095 9.5 7.5 9.5C5.65905 9.5 4.16667 8.00762 4.16667 6.16667C4.16667 4.32572 5.65905 2.83333 7.5 2.83333C9.34095 2.83333 10.8333 4.32572 10.8333 6.16667Z"
    />
  </svg>
);

export { SvgComponent as UsersIcon };

